var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRsvpTileWaveform = function SvgRsvpTileWaveform(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 108,
    viewBox: "0 0 279 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 166.997C22.5 116.5 10.0667 113.318 102.86 113.318C112.075 113.318 121.569 98.9928 129.945 86.3555C139.323 72.2056 148.181 58.8397 159.157 58.8397C169.392 58.8397 178.975 71.9324 189.122 85.7928C197.201 96.8264 206.357 109.334 212.786 109.334C219.214 109.334 224.606 92.8645 229.388 78.3373C236.844 55.6779 245.295 30 264.509 30C271.316 30 278.61 33.2659 286.81 39.9797L288 40.9556V167H0V166.997Z",
    fill: "url(#paint0_radial_2533_7962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5 118C93.4022 140.715 106.089 97.8112 113.52 84.8478C126.511 62.1783 132.007 56.0256 153.994 78.6463C175.978 101.267 185.805 0 202.126 0C216.002 0 215.118 61.8494 233.439 61.8494C247.095 61.8494 257.285 20.269 288 56.8595V149H0C17.1561 134.443 51.5 118 71.5 118Z",
    fill: "url(#paint1_radial_2533_7962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 86.2614C197.145 97.3878 206.375 110 212.856 110C219.337 110 224.772 93.3925 229.593 78.7433C237.11 55.8936 245.629 30 265 30",
    stroke: "url(#paint2_radial_2533_7962)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.993 151.318C209.201 151.318 218.689 136.993 227.059 124.356C236.429 110.206 245.285 96.8397 256.25 96.8397C266.477 96.8397 276.053 109.932 286.193 123.793C294.266 134.826 303.415 147.334 309.84 147.334C316.264 147.334 321.651 130.864 326.43 116.337C333.88 93.6779 342.325 68 361.526 68C368.328 68 375.616 71.2659 383.81 77.9797L385 78.9556V205H195",
    fill: "url(#paint3_radial_2533_7962)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2533_7962",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.5 49) rotate(64.6538) scale(42.0476 41.9337)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2533_7962",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157 100.5) rotate(-46.5975) scale(88.7764 88.6521)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EE68B",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22E04D",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2533_7962",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(226.933 69.9984) scale(39.1788 39.0832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2533_7962",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(189.101 5.55841) scale(157.915 157.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  })))));
};
export default SvgRsvpTileWaveform;